import { createFileRoute } from '@tanstack/react-router';
import { useFlagsStatus } from '@unleash/proxy-client-react';

import AuctionItemDetail from '@/components/_auctions/AuctionItemDetail.tsx';
import { AuctionLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';
import PageDisabled from '@/components/PageDisabled';
import useFlag from '@/lib/hooks/useFlag';

const AuctionItemPage = () => {
  const { id } = Route.useParams();

  const featuresReady = useFlagsStatus().flagsReady;
  const enableAuctions = useFlag('auctions');

  if (!featuresReady) {
    return <PageLoading />;
  }

  if (!enableAuctions) {
    return <PageDisabled absolutelyCentered />;
  }

  return <AuctionItemDetail itemId={id} />;
};

export const Route = createFileRoute('/auctions/$id')({
  component: () => (
    <AuctionLayout title="shared.navigation.auction">
      <AuctionItemPage />
    </AuctionLayout>
  ),
});
